module.exports = __webpack_public_path__ + "static/media/date_range-24px.a0a18102.svg";